import React, {useEffect, useState} from 'react';
import Link from "next/link";
import styled from "styled-components";
import {getWidgets} from "@models/widget";
import {getProperties} from "@models/search";
import LandingAreasSlider from "@organisms/property/landing/landing_areas_slider";
import LandingTile from "@organisms/property/landing/tiles";
import BrandingText from "@molecules/widgets/branding_text";
import FaqsWidget from "@molecules/widgets/faqs";
import RadiusGenerate from "@helpers/radius.generate";
import LandingProperties from "@organisms/property/landing/properties";
import MostActiveRealtor from "@molecules/realtor/most_active_realtors";
import VillaTypesSlider from "@organisms/property/landing/shomal/villa_types_slider";
import {isEmpty} from "@helpers/helpers";
import Icon from "@atoms/icon";
import {getSearchFaq} from "@organisms/property/helpers/search_helper";
import MostActiveAgencies from "../../../components/organisms/property/components/most_active_agencies";
import LandingSeeMorePropertyBtn from "@organisms/property/components/landing_see_more_property_btn";
import PeopleIcon from '@icons/people.svg';
import Coin2Icon from '@icons/coin2.svg';
import Coin3Icon from '@icons/coin3.svg';
import Coin4Icon from '@icons/coin4.svg';
import ArrowLeftIcon from '@icons/arrow-left.svg';


function Shomal({pageTitle, cityPropertiesWidget, handleBackFromLanding, specialCitiesLists, faqsList, ssrBrandingText, setContactInfo}) {

    const [specialCities, setSpecialCities] = useState(specialCitiesLists ?? []);
    const [properties, setProperties] = useState(cityPropertiesWidget ?? []);
    const [faqs, setFaqs] = useState(faqsList ?? []);

    useEffect(() => {

        if (!specialCities.length) {
            const params = {
                type: 'static_links',
                page: 'properties',
                section: 'related_cities',
                city_id: 3198,
                properties_types: 'villa',
                properties_deal_types: 'sale',
                count: 25
            };

            getWidgets(params).then(result => {
                setSpecialCities((!isEmpty(result) && result.widgets) ? result.widgets : [])
            })
        }

        if (!properties.length) {
            const propertiesParams = {
                city_id: 3198,
                types: ['villa'],
                deal_type: 'sale',
                sort: 'boosted_at',
                has_media: 1,
                exclude_archived: 1,
                count: 8
            };

            getProperties(1, null, propertiesParams).then(result => {
                setProperties(result.properties);
            })
        }

        if (!faqs.length) {
            const params = {
                city_id: 3198,
                types: ['villa'],
                deal_type: 'sale',
            };

            getSearchFaq(params).then(widgets => {
                setFaqs(widgets)
            });
        }

    }, []);

    useEffect(() => {
        if (!isEmpty(handleBackFromLanding)) {
            window.onpopstate = (ctx) => {
                if (!isEmpty(handleBackFromLanding)) {
                    handleBackFromLanding(ctx)
                }
            };
        }
    });

    const priceTileItems = [
        {title: 'تا 1٫5 میلیارد', href: '/properties', hrefAs: '/املاک-شمال/خرید-فروش-ویلا/قیمت-تا-1.500-میلیارد', icon: <Coin2Icon/>},
        {title: '1٫5 تا 3 میلیارد', href: '/properties', hrefAs: '/املاک-شمال/خرید-فروش-ویلا/قیمت-1.500-تا-3-میلیارد', icon: <Coin3Icon/>},
        {title: '3 تا 5 میلیارد', href: '/properties', hrefAs: '/املاک-شمال/خرید-فروش-ویلا/قیمت-3-تا-5-میلیارد', icon: <Coin4Icon/>},
    ];

    const realtorsTileItems = [
        {title: 'مشاورین نوشهر', crossOverLink: false, href: '/users/agencies', hrefAs: '/املاک-نوشهر/مشاورین-املاک', icon: <PeopleIcon/>},
        {title: 'مشاورین متل‌قو', crossOverLink: false, href: '/users/agencies', hrefAs: '/املاک-سلمانشهر-(-متل-قو-)/مشاورین-املاک', icon: <PeopleIcon/>},
        {title: 'مشاورین چمستان', crossOverLink: false, href: '/users/agencies', hrefAs: '/املاک-چمستان/مشاورین-املاک', icon: <PeopleIcon/>},
        {title: 'مشاورین رامسر', crossOverLink: false, href: '/users/agencies', hrefAs: '/املاک-رامسر/مشاورین-املاک', icon: <PeopleIcon/>},
    ];

    const LandingAreasSliderBreakpoints = {
        1024: {
            slidesPerView: 6,
        },
        768: {
            slidesPerView: 4.2,
        },
        320: {
            slidesPerView: 2.2,
        }
    };

    return (
        <Container className={'landing-page-container '}>

            <section className="mt-16 mt-lg-56">
                <div className="container">
                    <h1 className="mb-16">{pageTitle ?? 'خرید ویلا در شمال'}</h1>
                </div>
                <div className="container sm-fluid">
                    <LandingAreasSlider
                        items={specialCities}
                        breakpoints={LandingAreasSliderBreakpoints}
                        appendAs="/خرید-فروش-ویلا"
                        lazyLoad={false}
                    />
                </div>
            </section>

            <Sections className="mt-40 mt-lg-56">
                <div className="container">
                    <p className="mb-16"><strong className="h2">بر اساس نوع ویلا</strong></p>
                </div>

                <div className="container sm-fluid">
                    <VillaTypesSlider urlPrefix="/املاک-شمال/خرید-فروش-ویلا"/>
                </div>
            </Sections>

            <Sections className="container mt-40 mt-lg-56">
                <p className="mb-16"><strong className="h2">بر اساس قیمت ویلا در شمال</strong></p>
                <LandingTile iconsClassName="price" items={priceTileItems} iconSize={32}/>
            </Sections>

            <Sections className="container">
                <Link href="/properties" as="/املاک-شمال/خرید-فروش-ویلا/قیمت-5-میلیارد-به-بالا">
                    <a>
                        <ShomalBanner className="shomal-banner-lux rounded-16 d-flex flex-column align-items-center align-items-md-end justify-content-end justify-content-md-center">
                            <h2 className="h1-bold text-white d-flex align-items-end justify-content-between d-md-block">
                                <span className="">خرید ویلای <br/> لوکس و لاکچری </span>
                                <span className="shomal-banner-icon bg-white rounded-circle mr-24 d-inline-flex align-items-center justify-content-center">
                                    <Icon className=""><ArrowLeftIcon/></Icon>
                                </span>
                            </h2>
                        </ShomalBanner>
                    </a>
                </Link>
            </Sections>


            <Sections>
                <div className="container d-flex align-items-center justify-content-between mb-16">
                    <h2 className="">جدیدترین ویلاهای شمال</h2>

                    <div className="cities-show-more-wrapper d-none d-lg-block">
                        <LandingSeeMorePropertyBtn hrefAs={`/املاک-شمال/خرید-فروش-ویلا?sort=boosted_at`}/>
                    </div>
                </div>

                <div className="container sm-fluid">
                    <LandingProperties city_id={3198} properties={properties}/>
                </div>

                <div className="container mt-24 mt-lg-32 cities-show-more-wrapper d-lg-none">
                    <LandingSeeMorePropertyBtn hrefAs={`/املاک-شمال/خرید-فروش-ویلا?sort=boosted_at`}/>
                </div>
            </Sections>

            <Sections className="container">
                <Link href="/properties" as="/املاک-شمال/خرید-فروش-ویلا/استخردار">
                    <a>
                        <ShomalBanner className="shomal-banner-has-pool rounded-16 d-flex flex-column align-items-center align-items-md-end justify-content-end justify-content-md-center">
                            <h2 className="h1-bold text-white d-flex align-items-end justify-content-between d-md-block">
                                <span className="">خرید ویلای <br/> اســـــتخــردار</span>
                                <span className="shomal-banner-icon bg-white rounded-circle mr-24 d-inline-flex align-items-center justify-content-center">
                                    <Icon className=""><ArrowLeftIcon/></Icon>
                                </span>
                            </h2>
                        </ShomalBanner>
                    </a>
                </Link>
            </Sections>


            <Sections className="selected-realtors js-most-active-agency-section">

                <div className="container sm-fluid">
                    <MostActiveAgencies
                        city_id={3198}
                        setContactInfo={setContactInfo}
                        className=""
                        sectionTitle={`املاک منتخب شمال`}
                        count={28}
                    />
                </div>
            </Sections>

            <Sections className="container">
                <p className="mb-16"><strong className="h2">مشاورین متخصص ویلا در شمال</strong></p>
                <LandingTile items={realtorsTileItems} iconSize={24}/>
            </Sections>

            <Sections className="container">
                <Link href="/properties" as="/املاک-شمال/خرید-فروش-ویلا?has_video=1">
                    <a>
                        <HasVideoBanner className="rounded-16 d-flex flex-column align-items-center align-items-md-end justify-content-end justify-content-md-center">
                            <h2 className="h1-bold text-white d-flex align-items-end justify-content-between d-md-block">
                                <span className="">ویلاهای<br/> ویدئودار </span>
                                <span className="shomal-banner-icon bg-white rounded-circle mr-24 d-inline-flex align-items-center justify-content-center">
                                    <Icon className=""><ArrowLeftIcon/></Icon>
                                </span>
                            </h2>
                        </HasVideoBanner>
                    </a>
                </Link>
            </Sections>


            <Sections className="js-active-realtors-last-week">
                <div className="container">
                    <p className="mb-16"><strong className="h2">مشاورین فعال 7 روز اخیر شمال</strong></p>
                </div>

                <div className="container sm-fluid">
                    <MostActiveRealtor city_id={3198} last_week={true} sectionClassName="js-active-realtors-last-week"/>
                </div>
            </Sections>

            {
                (faqs.length) ?
                    <Sections className="container">
                        <FaqsWidget faqs={faqs}/>
                    </Sections>
                    : ''
            }

            <Sections className={"container "}>
                <BrandingText skeleton={false} content={ssrBrandingText} searchParams={{city_id: 3198, types: ['villa'], deal_type: 'sale'}}/>
            </Sections>

            <div className="mt-56"></div>
        </Container>
    )
}

export default React.memo(Shomal);

// styles
const Container = styled.div`

  &.search-navbar-fixed {
    margin-top: 120px !important;

    @media (max-width: ${props => props.theme.screenXsMax}) {
      margin-top: 0 !important;
    }
  }
`;

const Sections = styled.section`
  margin-top: 80px;

  @media (max-width: ${props => props.theme.screenSmMax}) {
    margin-top: 64px;
  }

  img {
    background-color: ${props => props.theme.gray100};
  }
`;

const ShomalBanner = styled.section`
  background-color: ${props => props.theme.gray100};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
  min-height: 280px;
  padding-left: 80px;
  ${RadiusGenerate(16)};

  .shomal-banner-icon {
    width: 28px;
    height: 28px;
  }

  &.shomal-banner-lux {
    background-image: url(/_img/landings/shomal-lux.jpg?v=1);
  }

  &.shomal-banner-has-pool {
    background-image: url(/_img/landings/villa-pool.jpg?v=1);
  }

  .icons {
    width: 16px;
    height: 16px;
    vertical-align: middle;

    svg {
      g {
        stroke-width: 2;
      }
    }
  }

  @media (max-width: ${props => props.theme.screenXsMax}) {
    min-height: 327px;
    padding: 32px;

    &.shomal-banner-lux {
      background-image: url(/_img/landings/shomal-lux-mobile.jpg?v=1);
    }

    &.shomal-banner-has-pool {
      background-image: url(/_img/landings/pool-m.jpg?v=1);
    }

    .shomal-banner-icon {
      margin-bottom: 7px;
    }

    h2 {
      width: 100%;

      span.lux-hint {
        font-size: 15px;
        font-weight: normal;
      }
    }

    .icons {
      width: 14px;
      height: 14px;
    }
  }
`;

const HasVideoBanner = styled(ShomalBanner)`
  background-image: url(/_img/landings/has_video_d_1.jpg?v=1);

  @media (max-width: ${props => props.theme.screenXsMax}) {
    background-image: url(/_img/landings/has_video_m_1.jpg?v=1);
  }
`


